var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconStorefront = function SvgIconStorefront(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.063 2.75h13.883a1.76 1.76 0 0 1 1.672 1.26l.003.01 1.34 4.706A1 1 0 0 1 22 9v1.5a4 4 0 0 1-1.5 3.123V19.5a1.75 1.75 0 0 1-1.75 1.75H5.25A1.75 1.75 0 0 1 3.5 19.5v-5.877A4 4 0 0 1 2 10.5V9a1 1 0 0 1 .038-.274L3.382 4.01a1.76 1.76 0 0 1 1.672-1.26zm.031 9.533a1 1 0 0 0-.192-.112A2 2 0 0 1 4 10.5V10h4v.5a2 2 0 0 1-2.906 1.783M5.5 14.47v4.781h13v-4.781a4 4 0 0 1-3.5-1.323 4 4 0 0 1-6 0 4 4 0 0 1-3.5 1.323M10 10.5a2 2 0 0 0 4 0V10h-4zM19.675 8l-.925-3.25H5.25L4.325 8zM20 10h-4v.5a2 2 0 0 0 2.906 1.783 1 1 0 0 1 .192-.111A2 2 0 0 0 20 10.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconStorefront;